import { PostType } from '@/types/wordpress'

import ArticlePreview from '../ArticlePreview/ArticlePreview'

import ArticlePagination from './ArticlePagination'

type Props = {
  pageCount: number
  pageNum: number
  path: string
  posts: PostType[]
}

const ArticleTypePage = ({ pageCount, pageNum, path, posts }: Props) => {
  if (path === 'guides') path = `/${path}/page`
  else if (path.startsWith('guides/page/')) path = `/${path}/page`
  else path = `/articles/${path}`

  return (
    <>
      {posts.length === 0 && <meta content='noindex' name='robots' />}
      <div className='d-flex flex-column gap-3'>
        {posts.length === 0 && <p>No articles found.</p>}
        {posts.map((post) => (
          <ArticlePreview key={post.slug} {...post} />
        ))}
      </div>
      <ArticlePagination pageCount={pageCount} pageNum={pageNum} path={path} />
    </>
  )
}

export default ArticleTypePage
